module.exports = {"140702001":"北关街道","140702002":"锦纶街道","140702003":"新华街道","140702004":"西南街道","140702005":"路西街道","140702006":"经纬街道","140702007":"安宁街道","140702008":"新建街道","140702009":"晋华街道","140702100":"乌金山镇","140702101":"东阳镇","140702102":"什贴镇","140702103":"长凝镇","140702104":"北田镇","140702105":"修文镇","140702200":"郭家堡乡","140702201":"张庆乡","140702202":"庄子乡","140702203":"东赵乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140702.json
// module id = 281
// module chunks = 0